// Shared vocabulary for a payout and its payment voucher — used by the phone's
// Earnings list + PayoutSheet and the desktop Earnings rail + drawer, so a
// payout reads the same on both builds.
import dayjs from 'dayjs';

// '2026-10-13' → '13 Oct 2026'. dayjs reads a bare date as LOCAL midnight; a
// `new Date('2026-10-13')` is UTC midnight and shows the day before anywhere
// west of Greenwich.
export const payoutDate = (ymd) => (ymd ? dayjs(ymd).format('D MMM YYYY') : '—');

export const isReversed = (p) => p?.status === 'REVERSED';

// The figure the agent actually received: the payout less any clawback HQ
// recovered out of it and any withholding tax kept back for LHDN. Older rows
// without `net` fall back to the gross.
export const payoutNet = (p) => Number(p?.net ?? p?.amount) || 0;

// What came off the payout before it reached the agent's bank, as the parts of
// one sentence: "RM 2,030.00 less RM 40.60 withholding tax 2%". Empty when
// nothing did. `rm` formats an amount the way the calling screen does.
export const payoutDeductions = (p, rm) => {
  const parts = [];
  const offset = Number(p?.clawback_offset) || 0;
  const tax = Number(p?.withholding_tax) || 0;
  if (offset > 0) parts.push(`${rm(offset)} clawback offset`);
  if (tax > 0) parts.push(`${rm(tax)} withholding tax 2%`);
  return parts.length ? `${rm(p.amount)} less ${parts.join(' and ')}` : '';
};

// The one sentence under a payout when there is no voucher number to show.
export const noVoucherLine = (p) => (isReversed(p)
  ? 'Reversed before a voucher was attached'
  : 'Voucher coming from HQ');
